import API from "./api";
import session from "../session";

const Get = async () => {
  let token = await session.GetHeader();
  try {
    const res = await API.get(`statustypes`, {
      headers: token,
    });
    return session.IsSessionExpired(res.data);
  } catch (err) {
    return { statusText: "Could not connect to server", status: 900 };
  }
};

export { Get };
